import BaseAPI from './base/base-api';

/**
 * API class cho MISA WebSocket Service (MWS) — lấy token kết nối broker.
 * Chỉ khai URL endpoint; httpClient gọi trong Vuex action (rule store action).
 */
class MwsAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'mws';
}

export default new MwsAPI();
